import { call, put, takeEvery } from "redux-saga/effects";
import { message } from 'antd';
import statusService from '../Actions/statusService';
import _GenericComponents from '../Actions/_GenericComponents';
import {getStatusSATDescargaMasivaRequest} from '../Api/StatusService';
const { types} = statusService;
const { actions } = _GenericComponents;
const { addStickyNote, removeStickyNote } = actions;

export function* getStatusSATDescargaMasiva() {
    try {
        let request = {
            service: 'satdescargamasiva'
        }
        const response = yield call(getStatusSATDescargaMasivaRequest, request);
        if (response && response.status === 'success' && response.data !== null) {
            let status = response.data;
            yield put(removeStickyNote({id:status.nombre}));
            if(status.estatus !== 'operational') {
                let alertType = 'warning'
                if (status.estatus === 'major_outage')
                    alertType = 'error'
                let note = {
                    id: status.nombre,
                    message: status.mensaje,
                    alertType
                }
                yield put(addStickyNote(note));
            }
            
        } else {
            message.error('Ocurrió un error al obtener el estatus del servicio de descarga masiva del SAT', 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } 
}

export function* statusServiceSaga() {
    yield takeEvery(types.GET_STATUS_SAT_DESCARGA_MASIVA, getStatusSATDescargaMasiva);
};